import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Exporte(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Steuern & Auswertung"
      title="Exporte – DATEV, ADDISON und mehr"
      subtitle="Exportieren Sie Ihre Buchhaltungsdaten in allen gängigen Formaten. Perfekte Zusammenarbeit mit Ihrem Steuerberater garantiert."
      heroImage="/screenshots/app-buchhaltung.webp"
      heroImageAlt="Buchhaltungsübersicht in Saldify – Grundlage für den DATEV-Export"
      features={[
        {
          title: 'DATEV-Export',
          description: 'Exportieren Sie Buchungen und Belege im DATEV-Buchungsstapel-Format.',
        },
        {
          title: 'ADDISON-kompatibel',
          description: 'Volle Unterstützung für ADDISON und andere Kanzleisoftware.',
        },
        {
          title: 'PDF-Berichte',
          description: 'Erstellen Sie professionelle PDF-Reports für Auswertungen und Präsentationen.',
        },
        {
          title: 'CSV & Excel',
          description: 'Exportieren Sie Daten für eigene Analysen in CSV oder Excel.',
        },
        {
          title: 'Belegbilder inklusive',
          description: 'Exportieren Sie Belege als strukturierte Bildarchive mit Verknüpfung zu Buchungen.',
        },
        {
          title: 'Automatisierte Exporte',
          description: 'Richten Sie regelmäßige Exporte ein, die automatisch an Ihren Steuerberater gesendet werden.',
        },
      ]}
      sections={[
        {
          title: 'Nahtlose Steuerberater-Zusammenarbeit',
          description: 'Der DATEV-Export ist der Standard für die Zusammenarbeit mit Steuerberatern. Saldify exportiert alle Buchungen und Belege im korrekten Format.',
          bullets: [
            'DATEV-Buchungsstapel',
            'Belegbilder im DATEV-Format',
            'Automatische Kontenzuordnung',
            'Fehlerfreie Übertragung',
          ],
          imageSide: 'right',
        },
        {
          title: 'Flexibel für jeden Bedarf',
          description: 'Ob für Ihren Steuerberater, die Bank oder eigene Analysen – exportieren Sie Ihre Daten genau so, wie Sie sie brauchen.',
          bullets: [
            'Zeitraum frei wählbar',
            'Konten und Kategorien filtern',
            'Mit oder ohne Belege',
            'Verschiedene Dateiformate',
          ],
          imageSide: 'left',
        },
      ]}
      ctaTitle="Exportieren Sie Ihre Daten"
      ctaDescription="Testen Sie die Export-Funktionen und erleben Sie, wie einfach die Zusammenarbeit mit Ihrem Steuerberater sein kann."
    />
  );
}
